import _regeneratorRuntime from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Range } from "../Range";
/**
 * @class
 * Class representing LargeFileUploadTask
 */

export var LargeFileUploadTask =
/*#__PURE__*/
function () {
  /**
   * @public
   * @constructor
   * Constructs a LargeFileUploadTask
   * @param {Client} client - The GraphClient instance
   * @param {FileObject} file - The FileObject holding details of a file that needs to be uploaded
   * @param {LargeFileUploadSession} uploadSession - The upload session to which the upload has to be done
   * @param {LargeFileUploadTaskOptions} options - The upload task options
   * @returns An instance of LargeFileUploadTask
   */
  function LargeFileUploadTask(client, file, uploadSession) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, LargeFileUploadTask);

    /**
     * @private
     * Default value for the rangeSize
     */
    this.DEFAULT_FILE_SIZE = 5 * 1024 * 1024;
    this.client = client;
    this.file = file;

    if (options.rangeSize === undefined) {
      options.rangeSize = this.DEFAULT_FILE_SIZE;
    }

    this.options = options;
    this.uploadSession = uploadSession;
    this.nextRange = new Range(0, this.options.rangeSize - 1);
  }
  /**
   * @public
   * @static
   * @async
   * Makes request to the server to create an upload session
   * @param {Client} client - The GraphClient instance
   * @param {any} payload - The payload that needs to be sent
   * @param {KeyValuePairObjectStringNumber} headers - The headers that needs to be sent
   * @returns The promise that resolves to LargeFileUploadSession
   */


  _createClass(LargeFileUploadTask, [{
    key: "parseRange",

    /**
     * @private
     * Parses given range string to the Range instance
     * @param {string[]} ranges - The ranges value
     * @returns The range instance
     */
    value: function parseRange(ranges) {
      var rangeStr = ranges[0];

      if (typeof rangeStr === "undefined" || rangeStr === "") {
        return new Range();
      }

      var firstRange = rangeStr.split("-");
      var minVal = parseInt(firstRange[0], 10);
      var maxVal = parseInt(firstRange[1], 10);

      if (Number.isNaN(maxVal)) {
        maxVal = this.file.size - 1;
      }

      return new Range(minVal, maxVal);
    }
    /**
     * @private
     * Updates the expiration date and the next range
     * @param {UploadStatusResponse} response - The response of the upload status
     * @returns Nothing
     */

  }, {
    key: "updateTaskStatus",
    value: function updateTaskStatus(response) {
      this.uploadSession.expiry = new Date(response.expirationDateTime);
      this.nextRange = this.parseRange(response.nextExpectedRanges);
    }
    /**
     * @public
     * Gets next range that needs to be uploaded
     * @returns The range instance
     */

  }, {
    key: "getNextRange",
    value: function getNextRange() {
      if (this.nextRange.minValue === -1) {
        return this.nextRange;
      }

      var minVal = this.nextRange.minValue;
      var maxValue = minVal + this.options.rangeSize - 1;

      if (maxValue >= this.file.size) {
        maxValue = this.file.size - 1;
      }

      return new Range(minVal, maxValue);
    }
    /**
     * @public
     * Slices the file content to the given range
     * @param {Range} range - The range value
     * @returns The sliced ArrayBuffer or Blob
     */

  }, {
    key: "sliceFile",
    value: function sliceFile(range) {
      var blob = this.file.content.slice(range.minValue, range.maxValue + 1);
      return blob;
    }
    /**
     * @public
     * @async
     * Uploads file to the server in a sequential order by slicing the file
     * @returns The promise resolves to uploaded response
     */

  }, {
    key: "upload",
    value: function upload() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var nextRange, err, fileSlice, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

              case 1:
                if (!true) {
                  _context.next = 18;
                  break;
                }

                nextRange = this.getNextRange();

                if (!(nextRange.maxValue === -1)) {
                  _context.next = 7;
                  break;
                }

                err = new Error("Task with which you are trying to upload is already completed, Please check for your uploaded file");
                err.name = "Invalid Session";
                throw err;

              case 7:
                fileSlice = this.sliceFile(nextRange);
                _context.next = 10;
                return this.uploadSlice(fileSlice, nextRange, this.file.size);

              case 10:
                response = _context.sent;

                if (!(response.id !== undefined)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", response);

              case 15:
                this.updateTaskStatus(response);

              case 16:
                _context.next = 1;
                break;

              case 18:
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 20]]);
      }));
    }
    /**
     * @public
     * @async
     * Uploads given slice to the server
     * @param {ArrayBuffer | Blob | File} fileSlice - The file slice
     * @param {Range} range - The range value
     * @param {number} totalSize - The total size of a complete file
     */

  }, {
    key: "uploadSlice",
    value: function uploadSlice(fileSlice, range, totalSize) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.client.api(this.uploadSession.url).headers({
                  "Content-Length": "".concat(range.maxValue - range.minValue + 1),
                  "Content-Range": "bytes ".concat(range.minValue, "-").concat(range.maxValue, "/").concat(totalSize)
                }).put(fileSlice);

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                throw _context2.t0;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));
    }
    /**
     * @public
     * @async
     * Deletes upload session in the server
     * @returns The promise resolves to cancelled response
     */

  }, {
    key: "cancel",
    value: function cancel() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.client.api(this.uploadSession.url).delete();

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                throw _context3.t0;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));
    }
    /**
     * @public
     * @async
     * Gets status for the upload session
     * @returns The promise resolves to the status enquiry response
     */

  }, {
    key: "getStatus",
    value: function getStatus() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.client.api(this.uploadSession.url).get();

              case 3:
                response = _context4.sent;
                this.updateTaskStatus(response);
                return _context4.abrupt("return", response);

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                throw _context4.t0;

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));
    }
    /**
     * @public
     * @async
     * Resumes upload session and continue uploading the file from the last sent range
     * @returns The promise resolves to the uploaded response
     */

  }, {
    key: "resume",
    value: function resume() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.getStatus();

              case 3:
                _context5.next = 5;
                return this.upload();

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                throw _context5.t0;

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));
    }
  }], [{
    key: "createUploadSession",
    value: function createUploadSession(client, requestUrl, payload) {
      var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var session, largeFileUploadSession;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return client.api(requestUrl).headers(headers).post(payload);

              case 3:
                session = _context6.sent;
                largeFileUploadSession = {
                  url: session.uploadUrl,
                  expiry: new Date(session.expirationDateTime)
                };
                return _context6.abrupt("return", largeFileUploadSession);

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                throw _context6.t0;

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 8]]);
      }));
    }
  }]);

  return LargeFileUploadTask;
}();